import * as React from 'react';

export const ServerError = () => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="wrapper wrapper-content">
                    <div className="errorscreen middle-box text-center animated fadeInDown">
                        <h1 className="logo-name">
                            <img src="/Content/Images/Misc/vitalograph-logo.png" alt="Vitalograph Logo" />
                        </h1>
                        <h3 className="font-bold">We have hit a problem</h3>
                        <div className="error-desc">
                            Unfortunately an error has occurred. The error details have been recorded. We apologize for any inconvenience caused. Please let us know by contacting Vitalograph Support Services
                        </div>
                        <a className="btn btn-sm btn-primary btn-block" href="/" style={{ marginTop: 25 + 'px' }}>Return to Home</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
